export default __webpack_public_path__ + "static/media/HDTX_Summary of GMS July 2022.1ee7a635.pdf";